// get single payment method

import type { MakeCall } from '../createMakeCall';
import { PaymentMethod } from './types';

const getPaymentMethod = (makeCall: MakeCall) => (uuid: string) =>
  makeCall<PaymentMethod>('GET', `/api/v2/payment/method/pay-in/${uuid}`);
export { getPaymentMethod };
